module.exports = __webpack_public_path__ + "static/media/document_Upload.c15887f5.png";